L.Behaviours = L.Class.extend({

	initialize: function(){
		this._behaviours = {
				'onClick': ['modal','popup','external','none'],
				'onOver': ['tooltip','none']
		};
		
	},
	
	addBehaviours: function(behavioursList){

		if (typeof(behavioursList) == Object){
			Object.assign( this._behaviours,behavioursList);
		}
		
	},

	setBehaviours: function(layer, data){

		var _containers = {
				'modal':{
					get: layer.getModal,
				},
				'popup':{
					get: layer.getPopup,
				},
				'tooltip':{
					get: layer.getTooltip,
				},
				'external':{
					get: layer.getLink,
				},
				'none':{
					get: function(){return false;}
				}
		};
		
		
		for (var idx in this._behaviours){
			if (data[idx]){
				for (var _containerIdx in this._behaviours[idx]){
					if (this._behaviours[idx][_containerIdx]==data[idx]['type']){
						this.setContainers(layer, data[idx]);
					}else{
						this.unsetContainer(layer, this._behaviours[idx][_containerIdx]);
					}
				}
				
			}else{
				for (var _containerIdx in this._behaviours[idx]){
					this.unsetContainer(layer, this._behaviours[idx][_containerIdx]);
				}
			}
		};
	},

	getBehaviours: function(layer, behaviour){

		var returnedBehaviours = {};

		if (this._behaviours[behaviour]){
			for (var idx in this._behaviours[behaviour]){
				var returnedContainer = this.getContainers(layer,this._behaviours[behaviour][idx]);
				if(returnedContainer){
					returnedBehaviours[_behaviour] = returnedContainer;
				}
			}

		}else{
			for (var _behaviour in this._behaviours){
				for (var containerIdx in this._behaviours[_behaviour]){
					var returnedContainer = this.getContainers(layer,this._behaviours[_behaviour][containerIdx]);
					if(returnedContainer){
						returnedBehaviours[_behaviour] = returnedContainer;
					}
				}
			};			
		}



		return returnedBehaviours;
	},

	setContainers(layer, data){

		var _containers = {
				'modal':{
					containerClass: L.Modal,
					bind: L.Layer.prototype.bindModal,
					unbind: layer.unbindModal,
					get: layer.getModal,
				},
				'popup':{
					containerClass: L.Popup,
					bind: L.Layer.prototype.bindPopup,
					unbind: layer.unbindPopup,
					get: layer.getPopup,
				},
				'tooltip':{
					containerClass: L.Tooltip,
					bind: L.Layer.prototype.bindTooltip,
					unbind: layer.unbindTooltip,
					get: layer.getTooltip,
				},
				'external':{
					containerClass: L.Link,
					bind: L.Layer.prototype.bindLink,
					unbind: layer.unbindLink,
					get: layer.getLink,
				},
				'none':{
					get: function(){return false;}
				}
		};
		


		

		if (data['type'] != 'none'){
			var container = new _containers[data['type']]['containerClass'](data['options'],layer);
			container.customOptions = data['options'];
			_containers[data['type']].bind.call(layer,container);
	
			if(data['enhancedContent']){
				this.setEnhancedContent(container, data['enhancedContent']);
			}
		}

	},
	
	unsetContainer: function(layer, dataType){
		
		var _containers = {
				'modal':{
					unbind: layer.unbindModal,
					get: layer.getModal,
				},
				'popup':{
					unbind: layer.unbindPopup,
					get: layer.getPopup,
				},
				'tooltip':{
					unbind: layer.unbindTooltip,
					get: layer.getTooltip,
				},
				'external':{
					unbind: layer.unbindLink,
					get: layer.getLink,
				},
				'none':{
					get: function(){return false;},
					unbind:  function(){return true;}
				}
		};
		
		if ((_containers[dataType].get != undefined) && (_containers[dataType].get.call(layer) != undefined)){

			_containers[dataType].unbind.call(layer);
			
		}		
		
	},

	getContainers(layer, container){
		var _containers = {
				'modal':{
					get: layer.getModal,
				},
				'popup':{
					get: layer.getPopup,
				},
				'tooltip':{
					get: layer.getTooltip,
				},
				'external':{
					get: layer.getLink,
				}, 
				'none':{
					get: function(){return false;}
				}

		};

		var returnedData = false;
		var returnedContainer = _containers[container].get.call(layer);

		
		if(returnedContainer){
			returnedData = {'type':container, 'options':returnedContainer.customOptions};
			returnedData['enhancedContent'] = this.getEnhancedContent(returnedContainer);
		}
		

		return returnedData;
	},


	setEnhancedContent(container,data){

		var enhancedContent = {};
		if (!data['type'] && !data['properties']){
			return false;
		}

		switch (data['type']) {
		case L.EnhancedContent.Custom.TYPE:
			enhancedContent = L.EnhancedContent.custom();
			enhancedContent.setHeader(data['properties']['header']);								
			enhancedContent.setContent(data['properties']['content']);
			container.bindCustomEnhancedContent(enhancedContent);	
			break;

		case L.EnhancedContent.Linked.TYPE:
			enhancedContent = L.EnhancedContent.linked();
			enhancedContent.setLinkedId(data['properties']['linkedId']);
			enhancedContent.setTemplateId(data['properties']['templateId']);
			container.bindLinkedEnhancedContent(enhancedContent);
			break;
		default:
			break;
		}

	},

	getEnhancedContent(container){

		var returnedData;
		var returnedEnhancedContent = false;
		
		if (container.getEnhancedContent){
			returnedEnhancedContent = container.getEnhancedContent();
		}

		if(returnedEnhancedContent){
			returnedData = {'type': returnedEnhancedContent.getType(),'options': returnedEnhancedContent.options, 'properties': returnedEnhancedContent.getProperties()}
		}
		return returnedData;

	},

});